type SearchQueryString = Record<string, DomainAndSubdomain>;
type DomainAndSubdomain = { domain: string; subdomain: string };

export const QUERY_TO_SUBDOMAIN_SKILL_MAPPING: SearchQueryString = {
  'математика и python для анализа данных': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  '3d animation': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  '3d graphics': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  '3d modeling': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  '3ds max': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'a/b testing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'abstract algebra': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'accounting analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'actuarial science': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'adobe illustrator': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'advanced data structures in java': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'advanced python': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'advanced writing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  advertising: {
    domain: 'business',
    subdomain: 'marketing',
  },
  'aerial robotics': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'agile development': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'agile meets design thinking': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'agile project management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'agile testing': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  ajax: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  algebra: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'algebra basica': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  algorithm: {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'algorithm design': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'algorithm python': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  algorithmic: {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'algorithmic thinking': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'algorithmic toolbox': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'algorithmic trading': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  algorithms: {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'algorithms on graphs': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'an introduction to interactive programming in python': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'an introduction to programming the internet of things (iot)': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  analytics: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'android app development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'android development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'android programming': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'android software development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'android studio': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  angular: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'angular 4': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'angular 5': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  angularjs: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'apache hadoop': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'apache spark': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'apache storm': {
    domain: 'information-technology',
    subdomain: 'support-and-operations',
  },
  api: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'application security': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'applied machine learning': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  ar: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  arcgis: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  arduino: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'asset management': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'asset pricing': {
    domain: 'business',
    subdomain: 'finance',
  },
  audit: {
    domain: 'business',
    subdomain: 'finance',
  },
  auditing: {
    domain: 'business',
    subdomain: 'finance',
  },
  'augmented reality': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  autocad: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  automata: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  aws: {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'aws services': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  banking: {
    domain: 'business',
    subdomain: 'finance',
  },
  'bash script': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  bayesian: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'bayesian models': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'bayesian statistics': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'behavioral economics': {
    domain: 'business',
    subdomain: 'finance',
  },
  'big data': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'big data analysis with scala and spark': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'big data analytics': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'big data free': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'big data hadoop': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'big data modeling and management systems': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'big data specialization': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  bim: {
    domain: 'information-technology',
    subdomain: 'data-management',
  },
  'bioinformatics specialization': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  biostatistics: {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  bitcoin: {
    domain: 'business',
    subdomain: 'finance',
  },
  'bitcoin trading': {
    domain: 'business',
    subdomain: 'finance',
  },
  blockchain: {
    domain: 'business',
    subdomain: 'finance',
  },
  blogging: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  blues: {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'blues guitar': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'book keeping': {
    domain: 'business',
    subdomain: 'finance',
  },
  bookkeeping: {
    domain: 'business',
    subdomain: 'finance',
  },
  brand: {
    domain: 'business',
    subdomain: 'marketing',
  },
  'brand and product management': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'brand management': {
    domain: 'business',
    subdomain: 'marketing',
  },
  branding: {
    domain: 'business',
    subdomain: 'marketing',
  },
  brokerage: {
    domain: 'business',
    subdomain: 'finance',
  },
  budget: {
    domain: 'business',
    subdomain: 'finance',
  },
  'budgeting and scheduling projects': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'build business and financial models': {
    domain: 'business',
    subdomain: 'finance',
  },
  'building your leadership skills': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'business administration': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  'business analysis': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'business analyst': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'business analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'business and financial modeling': {
    domain: 'business',
    subdomain: 'finance',
  },
  'business calculus': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'business communication': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'business finance': {
    domain: 'business',
    subdomain: 'finance',
  },
  'business intelligence': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'business intelligence concepts, tools, and applications': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'business model': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  'business plan': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  'business process': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'business statistics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'business writing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  c: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'c language': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'c programming': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'c#': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'c++': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  cad: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  calculus: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'calculus 1': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'calculus 2': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  cancer: {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'capital market': {
    domain: 'business',
    subdomain: 'finance',
  },
  'capital markets': {
    domain: 'business',
    subdomain: 'finance',
  },
  cartography: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  ceo: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'change management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  charting: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  cissp: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'civil 3d': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'client needs and software requirements': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'client server': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'climate change': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  cloud: {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'cloud computing': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'cloud computing applications': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'cloud computing concepts': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'cloud security': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'cluster analysis': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'college algebra': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  combinatorics: {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  commercialization: {
    domain: 'business',
    subdomain: 'marketing',
  },
  'community management': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  compilers: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'computational biology': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'computational finance': {
    domain: 'business',
    subdomain: 'finance',
  },
  'computational investing': {
    domain: 'business',
    subdomain: 'finance',
  },
  'computational linguistics': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'computational neuroscience': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'computer programs': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'computer vision': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'construction management': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'consumer behavior': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'content management system': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'content marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'content strategy': {
    domain: 'information-technology',
    subdomain: 'data-management',
  },
  'content strategy for professionals': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'content writing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'convex optimization': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'copenhagen business school': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  copyright: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  copywriter: {
    domain: 'business',
    subdomain: 'marketing',
  },
  copywriting: {
    domain: 'business',
    subdomain: 'marketing',
  },
  'corporate finance': {
    domain: 'business',
    subdomain: 'finance',
  },
  'corporate social responsibility': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'corporate training': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'cost accounting': {
    domain: 'business',
    subdomain: 'finance',
  },
  'cpa marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'creative writing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'creative writing: the craft of character': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'creative writing: the craft of plot': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'credit risk': {
    domain: 'business',
    subdomain: 'finance',
  },
  cryptocurrency: {
    domain: 'business',
    subdomain: 'finance',
  },
  cryptography: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'cryptography ii': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  css: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'customer analytics': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'customer journey': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'customer service': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'cyber security': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  cybersecurity: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'data analysis and interpretation': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'data analysis and statistical inference': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'data collection': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data driven decision making': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'data engineering': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'data manipulation at scale': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'data manipulation at scale: systems and algorithms': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'data mining': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data modeling': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data modelling': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data science python': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'data security': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data structure': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'data structures': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'data structures and algorithms': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'data structures and algorithms in java': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'data structures and algorithms specialization': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'data structures: measuring and optimizing performance': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'data visualization and communication with tableau': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'data warehouse': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data warehouse concepts, design, and data integration': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data warehousing': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data warehousing for business intelligence': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data warehousing for business intelligence specialization': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'data wrangling': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'database design': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  datawarehouse: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'day trading': {
    domain: 'business',
    subdomain: 'finance',
  },
  'decision-making and scenarios': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'decision making': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'decision tree': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'deep learning': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  derivatives: {
    domain: 'business',
    subdomain: 'finance',
  },
  'descriptive statistics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'design patterns': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'design sprint': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'design thinking': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'dev ops': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  devops: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'differential calculus': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'digital analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'digital analytics for marketing professionals: marketing analytics in practice': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'digital analytics for marketing professionals: marketing analytics in theory': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'digital design': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'digital image processing': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'digital marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'digital marketing channels: planning': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'digital marketing specialization': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'digital media': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'digital photography': {
    domain: 'information-technology',
    subdomain: 'support-and-operations',
  },
  'digital storytelling': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'discrete math': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'discrete mathematics': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'discrete optimization': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'distributed system': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'distributed systems': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'dynamic programming': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'e-commerce': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  econometrics: {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  economics: {
    domain: 'business',
    subdomain: 'finance',
  },
  'effective problem-solving and decision-making': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  email: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'email marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'engineering management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'english speaking': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'english writing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'enterprise architecture': {
    domain: 'information-technology',
    subdomain: 'data-management',
  },
  'entity framework': {
    domain: 'information-technology',
    subdomain: 'data-management',
  },
  environmental: {
    domain: 'information-technology',
    subdomain: 'data-management',
  },
  'environmental science and sustainability': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  epidemiology: {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'essentials of corporate finance': {
    domain: 'business',
    subdomain: 'finance',
  },
  'establishing a professional ‘self’ through effective intercultural communication': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'ethical hacker': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'ethical hacking': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  etl: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'etl testing': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'event management': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'excel charts': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'excel to mysql': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'excel to mysql: analytic techniques for business capstone': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'excel vba': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'exploratory data analysis': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'exploring and producing data for business decision making': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  facilitation: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'feature engineering': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'financial accounting': {
    domain: 'business',
    subdomain: 'finance',
  },
  'financial analysis': {
    domain: 'business',
    subdomain: 'finance',
  },
  'financial crisis': {
    domain: 'business',
    subdomain: 'finance',
  },
  'financial engineering': {
    domain: 'business',
    subdomain: 'finance',
  },
  'financial engineering and risk management': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'financial engineering and risk management part i': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'financial management': {
    domain: 'business',
    subdomain: 'finance',
  },
  'financial markets': {
    domain: 'business',
    subdomain: 'finance',
  },
  'financial modeling': {
    domain: 'business',
    subdomain: 'finance',
  },
  'financial modelling': {
    domain: 'business',
    subdomain: 'finance',
  },
  'financial planning and analysis': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'financial reporting': {
    domain: 'business',
    subdomain: 'finance',
  },
  'financial statements': {
    domain: 'business',
    subdomain: 'finance',
  },
  'finding hidden messages in dna (bioinformatics i)': {
    domain: 'business',
    subdomain: 'marketing',
  },
  fintech: {
    domain: 'business',
    subdomain: 'finance',
  },
  'firm level economics: consumer and producer behavior': {
    domain: 'business',
    subdomain: 'finance',
  },
  forecasting: {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'forensic accounting': {
    domain: 'business',
    subdomain: 'finance',
  },
  forex: {
    domain: 'business',
    subdomain: 'finance',
  },
  'foundations of everyday leadership': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'foundations of strategic business analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'foundations of teaching': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'french language': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'front-end javascript frameworks: angularjs': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'full stack web development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'full stack web development specialization': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'full stack web development specialization capstone project': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'functional program design': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'functional program design in scala': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'functional programming': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'functional programming in scala': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'functional programming in scala specialization': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'functional programming principles in scala': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'fundamental analysis': {
    domain: 'business',
    subdomain: 'finance',
  },
  'fundamentals of graphic design': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'fundamentals of project planning and management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'fundamentals of quantitative modeling': {
    domain: 'business',
    subdomain: 'marketing',
  },
  fundraising: {
    domain: 'business',
    subdomain: 'finance',
  },
  'game design': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'game dev': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'game development': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'game programming': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'game theory': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  gamification: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  gcp: {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'genome sequencing (bioinformatics ii)': {
    domain: 'information-technology',
    subdomain: 'networking',
  },
  geographic: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  geometry: {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'getting started with python': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'getting started: agile meets design thinking': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  gis: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  git: {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  github: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'global marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  google: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'google cloud': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'google cloud platform': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'google developer': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'google it': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'google it support': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  gpu: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  grammar: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'grammar and punctuation': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'grammar english': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'grant writing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'graph analytics for big data': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'graph theory': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  graphic: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'graphic design': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'graphic designs': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  graphics: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'graphics design': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'growth hacking': {
    domain: 'business',
    subdomain: 'marketing',
  },
  hadoop: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'hadoop mapreduce': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'hadoop platform and application framework': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'healthcare analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'healthcare data analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  heroku: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'high performance computing': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'higher school of economics': {
    domain: 'business',
    subdomain: 'finance',
  },
  hive: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  hotel: {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'hotel management': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'how to write an essay': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  hr: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  html: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'html and css': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'html basics': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'html css': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'html css javascript': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'html, css and javascript': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  html5: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'human-centered design: an introduction': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'human resource management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'human resources': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  ifrs: {
    domain: 'business',
    subdomain: 'finance',
  },
  illustration: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'image processing': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'industrial biotechnology': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'industrial design': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'industrial engineering': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'industry 4.0': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'inferential statistics': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  infographics: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  informatics: {
    domain: 'information-technology',
    subdomain: 'networking',
  },
  'information design': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'information retrieval': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'information security': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'information theory': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'initiating and planning projects': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'innovation management': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'inquiry based learning': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'inspiring leadership through emotional intelligence': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'instagram marketing': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'instructional design': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'integrated marketing communications': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'intellectual property': {
    domain: 'business',
    subdomain: 'finance',
  },
  'interaction design': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'interactive python': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'international taxation': {
    domain: 'business',
    subdomain: 'finance',
  },
  'international trade': {
    domain: 'business',
    subdomain: 'finance',
  },
  internet: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'internet of things': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'internet security': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  interview: {
    domain: 'business',
    subdomain: 'marketing',
  },
  'interview skills': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'introduction to big data': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'introduction to big data analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'introduction to corporate finance': {
    domain: 'business',
    subdomain: 'finance',
  },
  'introduction to css3': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'introduction to financial accounting': {
    domain: 'business',
    subdomain: 'finance',
  },
  'introduction to game design': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'introduction to game development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'introduction to genomic technologies': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'introduction to html5': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'introduction to operations management': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'introduction to project management principles and practices': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'introduction to search engine optimization': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'introduction to swift programming': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'introduction to the internet of things and embedded systems': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  inventory: {
    domain: 'business',
    subdomain: 'marketing',
  },
  investing: {
    domain: 'business',
    subdomain: 'finance',
  },
  investment: {
    domain: 'business',
    subdomain: 'finance',
  },
  'investment banking': {
    domain: 'business',
    subdomain: 'finance',
  },
  'investment management': {
    domain: 'business',
    subdomain: 'finance',
  },
  investments: {
    domain: 'business',
    subdomain: 'finance',
  },
  ios: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'ios app development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'ios app development basics': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'ios development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  iot: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'iphone app development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'it management': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'it support': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'java data structures': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'java programming': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'java programming for beginners': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'java programming: arrays, lists, and structured data': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'java programming: object-oriented design of data structures': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'java programming: solving problems with software': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  javascript: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'javascript design patterns': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'javascript for beginners': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'javascript testing': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  journalism: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  jquery: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  json: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  junit: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  jupyter: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  kafka: {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  kaggle: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'kali linux': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'kalman filter': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  kanban: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'knowledge management': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  kubernetes: {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'land management': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  language: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  leadership: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'leadership training': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'lean manufacturing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'lean six sigma': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'learning and development': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'linear algebra': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'linear programming': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'linear regression': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  linguistics: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  linux: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'linux basics': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'linux commands': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'linux for beginners': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'linux security': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'logistic regression': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  logistics: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'long short-term memory': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'machine learning foundations: a case study approach': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'machine learning python': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'machine learning with big data': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'machine learning: classification': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  macroeconomics: {
    domain: 'business',
    subdomain: 'finance',
  },
  'management accounting': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'management information systems': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'managerial accounting': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'managerial economics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'managing big data with mysql': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'managing project risks and changes': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  manufacturing: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'manufacturing process': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  mapreduce: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'market research': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'marketing analytics': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'marketing management': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  'marketing mix': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'marketing strategy': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'master algorithmic programming techniques': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'mathematical biostatistics boot camp 1': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'mathematical model': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  matlab: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'matlab simulink': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'matrix algebra': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'mean stack': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'medicinal chemistry': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  mentoring: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'mergers and acquisitions': {
    domain: 'business',
    subdomain: 'finance',
  },
  'meta analysis': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  meteor: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'micro economics': {
    domain: 'business',
    subdomain: 'finance',
  },
  microcontroller: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  microprocessor: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  microservices: {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'mobile app': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'mobile app development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'mobile application development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'mobile apps': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'mobile cloud computing with android': {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  'mobile web': {
    domain: 'information-technology',
    subdomain: 'support-and-operations',
  },
  'model validation': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'modeling risk and realities': {
    domain: 'business',
    subdomain: 'marketing',
  },
  monetization: {
    domain: 'business',
    subdomain: 'marketing',
  },
  mongodb: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'monitoring and evaluation': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'more introduction to financial accounting': {
    domain: 'business',
    subdomain: 'finance',
  },
  'multiplatform mobile app development with web technologies': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'multivariable calculus': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'music production': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'my sql': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  mysql: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  negotiation: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'network analysis': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'network security': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'network theory': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'neural networks': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  neuromarketing: {
    domain: 'business',
    subdomain: 'marketing',
  },
  nlp: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'node.js': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'node js': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  nodejs: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  nosql: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'np complete': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'number theory': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'numerical analysis': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  numpy: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  oauth: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'object-oriented design': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'object oriented design': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'object oriented programming': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'object oriented programming in java': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'objective c': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  octave: {
    domain: 'business',
    subdomain: 'marketing',
  },
  'online marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'online teaching': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  oop: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'open cv': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  operations: {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'operations analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'operations management': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'operations research': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  optics: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  optimization: {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'organizational analysis': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'organizational design': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'organizational development': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'organizational leadership': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  pandas: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'parallel computing': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'parallel programming': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'pattern recognition': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  pedagogy: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'pen testing': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'people analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'performance management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'personal branding': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'personnel management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  photoshop: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  php: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'php programming': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'pivot table': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  planning: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'portfolio and risk management': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  postgresql: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'pre calculus': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'predictive analytics': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  presentation: {
    domain: 'business',
    subdomain: 'marketing',
  },
  'presentation skills': {
    domain: 'business',
    subdomain: 'marketing',
  },
  pricing: {
    domain: 'business',
    subdomain: 'marketing',
  },
  'pricing strategy': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'primeros auxilios psicológicos (pap)': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  privacy: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'private equity': {
    domain: 'business',
    subdomain: 'finance',
  },
  'probability and statistics': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'problem solving': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'process control': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'process improvement': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'process mining': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  procurement: {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  product: {
    domain: 'business',
    subdomain: 'marketing',
  },
  'product design': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'product development': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'product management': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'product manager': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'product marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'programming for everybody (getting started with python)': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'programming for everybody (python)': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'programming languages': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'programming mobile applications for android handheld systems: part 1': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  project: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'project finance': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'project management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'project management: the basics for success': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'proposal writing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'public administration': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'public relations': {
    domain: 'business',
    subdomain: 'marketing',
  },
  python: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python data': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python data science': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python data structures': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python excel': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python for beginners': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python for everybody': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python for everybody specialization': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python for everyone': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python for genomic data science': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python machine learning': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python pandas': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python programming': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python rice': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'python specialization': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'quality control': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'quantitative finance': {
    domain: 'business',
    subdomain: 'finance',
  },
  quantum: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'quantum computing': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'quantum cryptography': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'quantum physics': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'queuing theory': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  r: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'r language': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'r programming': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'r studio': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  rails: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'rails with active record and action pack': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'random forest': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'rapid prototyping': {
    domain: 'information-technology',
    subdomain: 'support-and-operations',
  },
  'reactive programming': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'real estate': {
    domain: 'business',
    subdomain: 'finance',
  },
  'recommender systems': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  recruitment: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'regression analysis': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'regression models': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'regular expression': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'reinforcement learning': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'relational database': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'relational database support for data warehouses': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'relational databases': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'remote sensing': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'renewable energy': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'responsive web design': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'responsive website': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'responsive website basics: code with html, css, and javascript': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  restful: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'restful api': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  revenue: {
    domain: 'business',
    subdomain: 'finance',
  },
  'revenue management': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'rice python': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'risk assessment': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'risk management': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  robot: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  robotics: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'robotics engineer': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  rstudio: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  rtos: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  ruby: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'ruby on rails': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'ruby on rails: an introduction': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'ruby programming': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'ruby rails': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'running valuable design sprints': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'russian language': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  sap: {
    domain: 'information-technology',
    subdomain: 'support-and-operations',
  },
  scala: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'script writing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  scrum: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'search engine optimization': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'search engine optimization fundamentals': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'self-driving car': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  seo: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'seo training': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'server-side development with nodejs': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'shell scripting': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'signal processing': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'single page web applications with angularjs': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'six sigma': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'small business': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  'social entrepreneurship': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  'social media': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'social media analytics': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'social media marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'social network analysis': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'social norms': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'social skills': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'social work': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'socket programming': {
    domain: 'information-technology',
    subdomain: 'security',
  },
  software: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'software architecture': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'software design': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'software design pattern': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'software development': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'software development process': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'software processes and agile practices': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'software product management': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'software project management': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'software security': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'software testing': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  solidity: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  solidworks: {
    domain: 'information-technology',
    subdomain: 'cloud-computing',
  },
  songwriting: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'speech recognition': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'sports marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'spring boot': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'spring framework': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  spss: {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  sql: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'sql certification': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'sql database': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'sql server': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  stata: {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'statistical analysis': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'statistical inference': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'statistical modeling': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'statistical reasoning': {
    domain: 'information-technology',
    subdomain: 'support-and-operations',
  },
  'statistics in medicine': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'stochastic process': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'stock market': {
    domain: 'business',
    subdomain: 'finance',
  },
  'stock market investment': {
    domain: 'business',
    subdomain: 'finance',
  },
  'stock trading': {
    domain: 'business',
    subdomain: 'finance',
  },
  'stock valuation': {
    domain: 'business',
    subdomain: 'finance',
  },
  storytelling: {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'strategic leadership': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'strategic leadership and management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'strategic management': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'strategic planning': {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'strategic planning and execution': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'stress management': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'supply chain': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  sustainability: {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  'sustainable development': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  swift: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'swift programming': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'system design': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'systematic review': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'systems thinking': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  tableau: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'tableau training': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'tcp/ip': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  teaching: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'teaching english': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'technical analysis': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'technical writing': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  tensorflow: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'tensorflow python': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'test driven development': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'text mining': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'text retrieval and search engines': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'the arduino platform and c programming': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'the art of negotiation': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'the language and tools of financial analysis': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'the power of macroeconomics': {
    domain: 'business',
    subdomain: 'finance',
  },
  'the raspberry pi platform and python programming for the raspberry pi': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'theory of computation': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'time series': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'time series analysis': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  'time series forecasting': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  topology: {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  trading: {
    domain: 'business',
    subdomain: 'finance',
  },
  'training and development': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'transact sql': {
    domain: 'data-science',
    subdomain: 'probability-and-statistics',
  },
  translation: {
    domain: 'business',
    subdomain: 'business-strategy',
  },
  typography: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'ubuntu linux': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  ui: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'uml diagram': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'unconscious bias': {
    domain: 'business',
    subdomain: 'leadership-and-management',
  },
  'understanding financial markets': {
    domain: 'business',
    subdomain: 'finance',
  },
  unity: {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  unix: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'unsupervised learning': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'usability testing': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'user experience': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'user interface': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'using databases with python': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  'using python to access web data': {
    domain: 'data-science',
    subdomain: 'data-analysis',
  },
  ux: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'ux design': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'value investing': {
    domain: 'business',
    subdomain: 'finance',
  },
  'vector calculus': {
    domain: 'data-science',
    subdomain: 'machine-learning',
  },
  'venture capital': {
    domain: 'business',
    subdomain: 'entrepreneurship',
  },
  'verified certificate': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'version control': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'video game design': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'viral marketing': {
    domain: 'business',
    subdomain: 'marketing',
  },
  'virtual reality': {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  'virtual teaching': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'visual basic': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'visual basic for applications': {
    domain: 'computer-science',
    subdomain: 'algorithms',
  },
  'visual design': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  vocal: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  'vocal training': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  vr: {
    domain: 'computer-science',
    subdomain: 'design-and-product',
  },
  web: {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'web accessibility': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'web analytics': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'web application': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'web applications': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'web apps': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'web crawler': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'web design': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'web design for everybody': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'web designing': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'web development': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  'web programming': {
    domain: 'information-technology',
    subdomain: 'data-management',
  },
  'web scraping': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'web server': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'web services': {
    domain: 'computer-science',
    subdomain: 'software-development',
  },
  'website design': {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
  wireless: {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'wireless technology': {
    domain: 'computer-science',
    subdomain: 'computer-security-and-networks',
  },
  'workforce development': {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  write: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  writing: {
    domain: 'business',
    subdomain: 'business-essentials',
  },
  xcode: {
    domain: 'computer-science',
    subdomain: 'mobile-and-web-development',
  },
};
